import axios from "axios";
import qs from "qs";
// import { history } from 'react-router-dom';
import Storage from "./Storage";
import { detect } from "detect-browser";
import { routes } from "../constants/constant.route";
// import AuthService from "./AuthService";
import { getScreenResolution } from "../utils/utils";

const API_URL = process.env.VITE_APP_API_URL;
const { LOGIN } = routes.AUTH;

function refreshRequestToken(refreshToken) {
  const refreshTokenBody = {
    refresh_token: refreshToken,
    grant_type: "refresh_token"
  };
  return request("POST", `${API_URL}${LOGIN}`, null, refreshTokenBody, {
    "content-type": "application/x-www-form-urlencoded",
    app: "baadshah"
  })
    .then(data => {
      const response = data.data;

      const obj = {
        accessToken: response.accessToken,
        accessTokenExpiresAt: response.accessTokenExpiresAt,
        refreshToken: response.refreshToken,
        refreshTokenExpiresAt: response.refreshTokenExpiresAt
      };
      const userDetail = response.user;
      Storage.setTokenDetail(obj);
      Storage.setUserDetail(userDetail);
      return Promise.resolve(data);
      // store token to localstorage and send seconde request
    })
    .catch(e => {
      const err =
        e.response && e.response.data && e.response.data.error[0]
          ? e.response.data.error[0]
          : null;
      const errorName = err ? err.name : "";
      if (errorName === "invalid_grant") {
        Storage.removeKeepMeLoggedInCookie();
        Storage.removeTokenDetail();
        Storage.removeUserDetail();
        window.location.replace("/login");
        return Promise.reject(e);
      }
      return Promise.reject(e);
      // remove tokens and redirect to logout
    });
}

/**
 * request interceptors
 * @param {String} method GET,PUT,POST,DELETE
 * @param {String} url req url
 * @param {Object} params query parameters
 * @param {Object} body req body
 * @param {Object} headers req headers
 */
export const request = (method, url, params, body = {}, headers = {}, timeoutForRequest) => {
  const token = Storage.getTokenDetail();
  const browser = detect();
  let browserName = browser.name;
  let version = browser.version;
  // let os = browser.os;
  const timeout = timeoutForRequest ? timeoutForRequest : 0;
  // handle the case where we don't detect the browser
  // if (browser) {
  // }
  headers = headers || {};
  params = params || {};
  body = body || {};

  headers["device_type"] = "browser";
  headers["web_version"] = version;
  headers["browser_name"] = browserName;
  headers["app"] = "baadshah";
  headers.resolution = getScreenResolution();

  if (!headers["content-type"]) {
    headers["content-type"] = "application/json";
  }

  if (
    !(
      url.includes("login") ||
      url.includes("forgot-password") ||
      url.includes("crm-points/about")
    )
  ) {
    if (token) {
      headers.Authorization = `Bearer ${token.accessToken}`;
    }
    // headers.Authorization = 'Bearer e6ecea97ca8beda3211586f82eb3d065a6579b26';
  } else if (url.includes("login")) {
    headers.Authorization = "Basic amt0eXJlOjEyMw==";
  }

  // if (url.includes('login')) {
  //   body.grant_type = 'password';
  // }

  const options = {
    method,
    headers,
    params,
    url,
    timeout
  };

  if (
    (method === "POST" || method === "PUT") &&
    headers["content-type"] === "application/x-www-form-urlencoded"
  ) {
    options.data = qs.stringify(body);
  } else if (
    (method === "POST" || method === "PUT") &&
    headers["content-type"] === "multipart/form-data"
  ) {
    if (body instanceof FormData) {
      options.data = body;
      delete headers["content-type"]; // Let browser set the content-type with boundary
    } else {
      headers["content-type"] = "multipart/form-data";
      // prepate multipart formdata body
      const formData = new FormData();
      const keys = Object.keys(body);
      for (let i = 0; i < keys.length; i++) {
        formData.append(keys[i], body[keys[i]]);
      }
      options.data = formData;
    }
  } else if (method === "POST" || method === "PUT") {
    options.data = body;
  }

  return axios(options)
    .then(data => {
      return Promise.resolve(data);
    })
    .catch(e => {
      console.log("request error", e.response);
      const err =
        e.response &&
          e.response.data &&
          e.response.data.error &&
          e.response.data.error[0]
          ? e.response.data.error[0]
          : null;
      const errorName = err ? err.name : "";
      const preserveRequest = options;
      if (errorName === "invalid_token") {
        return refreshRequestToken(token.refreshToken)
          .then(data => {
            const accessToken = data.data.accessToken;
            preserveRequest.headers.Authorization = `Bearer ${accessToken}`;
            return axios(preserveRequest);
          })
          .then(data => {
            return Promise.resolve(data);
          })
          .catch(e => {
            return Promise.reject(e);
          });
      }

      if (errorName !== "invalid_token") {
        return Promise.reject(e);
      }
    });
};
